import React, { useContext } from "react";
import InputDate from "core/inputs/input-date/InputDate";
import InfoContext from "pages/InfoContext";
import { Controller } from "react-hook-form";

const DateField = () => {
  const { control, setValue, errors, lang } = useContext(InfoContext);

  return (
    <Controller
      control={control}
      name="date_filter"
      rules={{
        required: true,
      }}
      render={({ field }) => (
        <InputDate
          required={true}
          lang={lang}
          label={{
            id: "date",
            defaultMessage: "Date",
          }}
          id="mission-date-filter"
          onChange={(e) => {
            field.onChange(e?.target?.value);
            setValue("date_filter", e?.target?.value);
          }}
          value={field.value || ""}
          errors={errors["date_filter"]}
        />
      )}
    />
  );
};

export default DateField;
